import { Injectable } from '@angular/core';
import { Input } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { strictEqual } from 'assert';

@Injectable({
  providedIn: 'root'
})
export class SharedValueService {

  constructor() { }

  isLoggedIn = false;
  strUid = "";
  strLoginUser = "";
  strEmail = "";

}
